import {EMessageType} from '../../Constants/Interfaces';
import * as React from 'react';
import classNames from 'classnames';
import {Avatar} from '../Avatar/Avatar';
import moment from 'moment';
import './Message.sass';


export interface IMessageProps {
    message: string;
    align?: 'right' | 'left';
    avatar?: string;
    name?: string;
    online?: boolean;
    persist?: boolean;
    unread?: boolean;
    setMessageRead?: () => any;
    blocked?: boolean;
    type?: EMessageType;
    isMyMessage?: boolean;
    timestamp: number;
    edited?: boolean;
}


export const Message: React.FC<IMessageProps> = ({
    align = 'left',
    avatar = '',
    online,
    message,
    name,
    unread,
    setMessageRead,
    blocked,
    type = EMessageType.default,
    isMyMessage,
    timestamp,
    edited,
}) => {
    const isRightAligned: boolean = align === 'right' || !!isMyMessage;

    const userName = (name || '').split('#');

    React.useEffect(() => {
        if (unread && !isMyMessage && setMessageRead) {
            setMessageRead();
        }
    }, []);

    const isSystemMessage = type === EMessageType.system;
    const includesLink = message.includes('https');

    const messageDate = new Date(timestamp);

    return (
        <div className={classNames('mvc-message', align, type)}>
            {avatar !== undefined && type !== EMessageType.system && (
                <Avatar
                    uri={avatar}
                    online={online}
                    size={24}
                    style={isRightAligned ? {marginLeft: 8} : {marginRight: 8}}
                />
            )}
            <div
                className={classNames('mvc-message-text', {
                    blocked,
                })}
            >
                {name && !isSystemMessage && !isMyMessage && (
                    <div className={'mvc-message-name'}>
                        {name && userName[0]}
                        {userName[1] && (<span className={'mvc-message-name-id'}>#{userName[1]}</span>)}
                        <span className={'mvc-message-timestamp'}>
                    {moment(messageDate).format('MMM DD HH:mma')}
                            {edited && '  (edited)'}
                </span>
                    </div>
                )}
                {blocked
                    ? 'Blocked message'
                    : includesLink
                        ? detectAndRenderURL(message)
                        : message}

            </div>


        </div>
    );
};


function detectAndRenderURL(message: string) {
    const messageArray = message.split(' ');
    return messageArray.map((string, i) => {
        if (string.includes('https')) {
            let link = string;
            let text = string;
            if (string.includes('|')) {
                const separated = string.split('|');
                link = separated[1];
                text = separated[0];
            }
            return (
                <span
                    className={'mvc-link'}
                    key={i}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open(link);
                    }}
                    style={{cursor: 'pointer'}}
                >
          {text + ' '}
        </span>
            );
        }
        else {
            return string + ' ';
        }
    });
}
